// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YhjZ","top":"styles_top__10kJy"};